// ABOUTME: API client for billing endpoints.
// ABOUTME: Handles checkout, portal, and usage queries.

import { apiFetch } from './client';
import type { UsageSummary, CheckoutSession, BillingPortal } from '@/types/api';

export const billingApi = {
  async getUsage(workspaceId?: string): Promise<UsageSummary> {
    const params = workspaceId ? `?workspace_id=${workspaceId}` : '';
    return apiFetch<UsageSummary>(`/users/me/usage${params}`);
  },

  async createCheckoutSession(
    successUrl: string,
    cancelUrl: string
  ): Promise<CheckoutSession> {
    return apiFetch<CheckoutSession>('/billing/checkout', {
      method: 'POST',
      body: JSON.stringify({
        success_url: successUrl,
        cancel_url: cancelUrl,
      }),
    });
  },

  async createBillingPortalSession(returnUrl: string): Promise<BillingPortal> {
    return apiFetch<BillingPortal>('/billing/portal', {
      method: 'POST',
      body: JSON.stringify({ return_url: returnUrl }),
    });
  },

  async reactivateSubscription(): Promise<{ status: string }> {
    return apiFetch<{ status: string }>('/billing/reactivate', {
      method: 'POST',
    });
  },
};
